const types = {
  404: {
    img: require('@/assets/exception/404.png'),
    title: '404',
    desc: '抱歉，你访问的页面不存在或仍在开发中'
  },
  500: {
    img: require('@/assets/exception/500.png'),
    title: '500',
    desc: '抱歉，服务器出错了'
  },
  600: {
    img: require('@/assets/exception/600.png'),
    title: '600',
    desc: '抱歉，服务器已断开'
  }
}

export default types
